import axios from 'axios'

import store from '../../../store/store'
let cashDeskToken = store.getters['AuthModule/cashDeskWorkstationID']
let cashDeskID = store.getters['AuthModule/cashDeskID']
let branchOfficeID = store.getters['AuthModule/branchOfficeID']

const route = process.env.VUE_APP_API_ROUTE + `/pos_ticket_counter`
const routeInvoice = process.env.VUE_APP_API_ROUTE + `/pos_invoice_counter`
const routeCreditNote =
    process.env.VUE_APP_API_ROUTE + `/sl_credit_note_counter`
const routeTransbank = process.env.VUE_APP_API_ROUTE + `/pos_voucher_counter`

const getTicketNumber = async (route, officeID) => {
    let response = await axios.get(route)
    if (response.data.data.length === 1) return response.data.data[0].counter
    response = response.data.data.find(
        counter => counter.g_branch_office_id == officeID
    )
    return response.counter
}

const getFullCounter = async (route, name) => {
    route = route + '_by_cash_desk_token'
    let response = await axios.get(route)
    let { counter, counter_end } = response.data
    return {
        counter,
        counter_end,
        name,
    }
}

const getAllCounters = (deskID = cashDeskID) => {
    return new Promise((resolve, reject) => {
        Promise.all([
            getFullCounter(route, 'Ticket'),
            getFullCounter(routeInvoice, 'Invoice'),
            getFullCounter(routeCreditNote, 'CreditNote'),
            getTransbankNumber(deskID),
        ])
            .then(rs => {
                resolve(
                    rs.reduce((obj, r) => {
                        if (!r.name) {
                            obj['initialTransbankNumber'] = r
                        } else {
                            obj[`initial${r.name}Number`] = r.counter
                            obj[`final${r.name}Number`] = r.counter_end
                        }
                        return obj
                    }, {})
                )
            })
            .catch(reject)
    })
}

const getIntegrationTicketNumber = async officeID => {
    //return getTicketNumber(route, officeID)
    let a = await getFullCounter(route, 'Ticket')
    return a.counter
}

const getIntegrationInvoiceTicketNumber = async officeID => {
    //return getTicketNumber(routeInvoice, officeID)
    let b = await getFullCounter(routeInvoice, 'Invoice')
    return b.counter
}

const getIntegrationCreditNoteNumber = async officeID => {
    //return getTicketNumber(routeCreditNote, officeID)
    let b = await getFullCounter(routeCreditNote, 'CreditNote')
    return b.counter
}

const getTransbankNumber = async (
    deskID = store.getters['AuthModule/cashDeskID']
) => {
    /*
    if (!deskID) {
        deskID = await store.dispatch('AuthModule/fetchCashDeskID')
    }
    */
    let response = await axios.get(routeTransbank + `/${deskID}`)
    let number = response.data.counter
    return number
}

const sendTicketNumber = route => async (counter, counterEnd = null) => {
    let data = {
        cash_desk_token: cashDeskToken,
        counter: counter,
        counter_end: counterEnd,
    }
    if (!data.counter_end) delete data.counter_end
    let r = await axios.post(route, data)
    return r
}

const sendTbkNumber = async (route, number, deskID = cashDeskID) => {
    let r = await axios.post(route, {
        pos_cash_desk_id: deskID,
        counter: number,
    })
    return r
}
const sendIntegrationTicketNumber = (counter, counterEnd = null) => {
    return sendTicketNumber(route)(counter, counterEnd)
}

const sendIntegrationInvoiceTicketNumber = async (counter, counterEnd) => {
    return sendTicketNumber(routeInvoice)(counter, counterEnd)
}

const sendIntegrationCreditNoteNumber = async (counter, counterEnd) => {
    return sendTicketNumber(routeCreditNote)(counter, counterEnd)
}

const sendTransbankNumber = async (
    tbk,
    deskID = store.getters['AuthModule/cashDeskID']
) => {
    console.log('TBK', tbk, deskID)
    return sendTbkNumber(routeTransbank, tbk, deskID)
}

export {
    getIntegrationTicketNumber,
    sendIntegrationTicketNumber,
    getIntegrationInvoiceTicketNumber,
    sendIntegrationInvoiceTicketNumber,
    getIntegrationCreditNoteNumber,
    sendIntegrationCreditNoteNumber,
    getTransbankNumber,
    sendTransbankNumber,
    getAllCounters,
}
